/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import useFetchLog, { FetchLogsProps } from './useFetchLog';
import { useVisibilityChange } from './useVisibilityChange';

const LOG_REFETCH_INTERVAL = 2000;

const useFetchNextLogs = ({
  buildData,
  logData,
}: FetchLogsProps): { errorStatus: number | undefined; isArchived: boolean } => {
  const { errorStatus, fetchPage, isArchived } = useFetchLog({ buildData, logData }, 'nextPage');
  const { isBuildStarted, isBuildRunning } = buildData;

  const isPageVisible = useVisibilityChange();

  useEffect(() => {
    if (!isBuildStarted || !isBuildRunning) {
      return () => {};
    }

    let timer: number;
    const refetchLogs = async () => {
      if (isPageVisible) await fetchPage();
      timer = window.setTimeout(refetchLogs, LOG_REFETCH_INTERVAL);
    };
    refetchLogs();

    return () => {
      window.clearTimeout(timer);
    };
  }, [isBuildStarted, isBuildRunning, fetchPage, isPageVisible]);

  useEffect(() => {
    if (isBuildStarted && !isBuildRunning) {
      fetchPage();
    }
  }, [isBuildStarted, isBuildRunning]);

  return { errorStatus, isArchived };
};

export default useFetchNextLogs;
